import { UrlBuilder } from "./urlBuilder";
export const QubictronHostnames = {
  loc: "www.qubictron.loc",
  dev: "dev.qubictron.com",
  release: "release.qubictron.dev",
  prod: "www.qubictron.com"
};
export const QubictronAppsHostnames = {
  dev: "apps.dev.qubictron.com",
  release: "release.apps.qubictron.com",
  prod: "apps.qubictron.com"
};
export const Hostnames = {
  localhost: "localhost"
};
export const QubictronBackofficeHostnames = {
  loc: "back-office.qubictron.loc",
  dev: "back-office.dev.qubictron.com",
  prod: "back-office.qubictron.com"
};

/** Suffix shared by every host of the local `.loc` stack. */
export const QUBICTRON_LOC_SUFFIX = ".qubictron.loc";

/** Suffix shared by every host of the dev stack (the site, its apps and back office). */
export const QUBICTRON_DEV_SUFFIX = ".dev.qubictron.com";

/**
 * @description Whether a hostname belongs to the local `.loc` stack
 * (the site, the back office, or any other host served from it).
 */
export const isQubictronLocHostname = hostname => hostname.endsWith(QUBICTRON_LOC_SUFFIX);

/**
 * @description Whether a hostname belongs to the dev stack. The site itself is
 * `dev.qubictron.com`, one level above the suffix its sibling hosts share.
 */
export const isQubictronDevHostname = hostname => hostname === QubictronHostnames.dev || hostname.endsWith(QUBICTRON_DEV_SUFFIX);

/**
 * @see {@link https://developer.mozilla.org/docs/Web/API/URL/protocol | MDN Reference}
 */
export const ProtocolMap = {
  https: "https:",
  http: "http:"
};
export const qubictronUrlMap = {
  loc: () => new UrlBuilder(`${ProtocolMap.https}//${QubictronHostnames.loc}`),
  dev: () => new UrlBuilder(`${ProtocolMap.https}//${QubictronHostnames.dev}`),
  release: () => new UrlBuilder(`${ProtocolMap.https}//${QubictronHostnames.release}`),
  prod: () => new UrlBuilder(`${ProtocolMap.https}//${QubictronHostnames.prod}`)
};
export const qubictronAppsUrlMap = {
  dev: () => new UrlBuilder(`${ProtocolMap.https}//${QubictronAppsHostnames.dev}`),
  release: () => new UrlBuilder(`${ProtocolMap.https}//${QubictronAppsHostnames.release}`),
  prod: () => new UrlBuilder(`${ProtocolMap.https}//${QubictronAppsHostnames.prod}`)
};
export const qubictronBackofficeUrlMap = {
  loc: () => new UrlBuilder(`${ProtocolMap.https}//${QubictronBackofficeHostnames.loc}`),
  dev: () => new UrlBuilder(`${ProtocolMap.https}//${QubictronBackofficeHostnames.dev}`),
  prod: () => new UrlBuilder(`${ProtocolMap.https}//${QubictronBackofficeHostnames.prod}`)
};
export const chineseBrothersUrlMap = {
  prod: () => new UrlBuilder(`${ProtocolMap.https}//www.chinese-brothers.com`)
};
export const localhostUrlBuilder = () => new UrlBuilder(`${ProtocolMap.http}//${Hostnames.localhost}`);

/**
 * @description Hostnames that are considered as development hosts.
 */
export const devHostnames = [localhostUrlBuilder().hostname, qubictronUrlMap.loc().hostname, qubictronUrlMap.dev().hostname, qubictronAppsUrlMap.dev().hostname];

/**
 * @description Hostnames that are considered as production hosts.
 */
export const prodHostnames = [qubictronUrlMap.prod().hostname, qubictronUrlMap.release().hostname, qubictronAppsUrlMap.release().hostname, qubictronAppsUrlMap.prod().hostname];